<template>
	<div class="page-header cm-header">
		<div class="container">
			<slot name="page-header"></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PageHeader',
}
</script>

<style scoped lang="scss"></style>
